<template id="app">
  <router-view></router-view>
</template>
<script>
//默认语言
export default {
  //预渲染
  mounted(){

  },
}
</script>
<style>
/*@import url('https://fonts.googleapis.com/css?family=Barlow');*/
@font-face {
  font-family: 'PingFang SC';
  src: url('@/assets/pingfangsc.ttf');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'iconfont';
  src: url('@/assets/iconfont.ttf');
}
.iconfont {
  font-family: iconfont;
}
body{ background:#FFFFFF; font-family:'PingFang SC'; margin:0; padding:0;}
#app{ padding:0; margin:0;}
/*@media only screen and (max-width: 1320px) {*/
/*  #app{ width: 96%; padding:0 2%;}*/
/*}*/
/*@media only screen and (max-width: 900px) {*/
/*  #app{ width: 100%; padding: 0;}*/
/*}*/
</style>